import { AlertTriangle } from "lucide-react";
import { Input } from "./Input";
import type { InputProps } from "./Input";
import cn from "@/lib/cn";

interface InputFieldProps extends InputProps {
  label?: string;
  errorMessage?: string;
}

export function InputField({
  label,
  errorMessage,
  className,
  ...props
}: InputFieldProps) {
  const hasError = Boolean(errorMessage);

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {label && (
        <label
          htmlFor={props.name}
          className="text-status-neutral-content text-[13px] font-semibold"
        >
          {label}
        </label>
      )}

      <Input id={props.name} error={hasError} {...props} />

      {hasError && (
        <span className="flex items-center gap-1 text-[12px] font-medium text-[#E02800]">
          <AlertTriangle className="size-3 shrink-0" strokeWidth={2} />
          {errorMessage}
        </span>
      )}
    </div>
  );
}
